import Vue from "vue";
export default Vue.extend({
    name: "WaveLoader",
    props: {
        title: { type: String, default: "" },
        // supports line breaks via \n (rendered with white-space: pre-line)
        message: { type: String, default: "" },
    },
});
